import React, { useEffect, useState } from 'react';
import styles from './RangeSlider.module.css';

// Define the interface for props
interface RangeSliderProps {
  min: number;
  max: number;
  onChange: (value: number) => void;
  id: string;
  value : number;
}

const RangeSlider: React.FC<RangeSliderProps> = ({ min, max, onChange, id,value }) => {
  // Initialize state with the minimum value
  const [rangeSliderValue, setRangeSliderValue] = useState(min);

  useEffect(()=>{
    setRangeSliderValue(min);
  },[min])

  useEffect(() => {
    const slider = document.getElementById(id) as HTMLInputElement | null;

    if (slider) {
      const value = slider.valueAsNumber;
      slider.style.background = `linear-gradient(to right, #0A4C8C ${(value / max * 100)}%, #ddd ${value / max * 100}%)`;
    }
  }, [rangeSliderValue, id, max,value]);

  return (
    <div className="items-center justify-center">
      <input
        type="range"
        className={styles.slider}
        min={min}
        max={max}
        onChange={(event) => {
          const value = Number(event.target.value);
          setRangeSliderValue(value);
          onChange(value);
        }}
        value={value}
        id={id}
      />
    </div>
  );
};

export default RangeSlider;
